import React from 'react';
import { motion } from 'framer-motion';
import { Target, Users, Award } from 'lucide-react';
const objectives = [{
  icon: Target,
  title: 'Enable HCP Presentation',
  description: 'Empower healthcare professionals to confidently present favorable Tralokinumab data with clarity and conviction'
}, {
  icon: Users,
  title: 'Leverage KEE Advocacy',
  description: 'Harness the credibility of strong key external experts as indirect advocates for Tralo and Leo Pharma'
}, {
  icon: Award,
  title: 'Reward Speaker Vanity',
  description: 'Elevate speaker profiles and expertise, making them feel like recognized masters in their field'
}];
export function StrategicIntent() {
  return <section className="py-24 bg-white" data-id="element-75">
      <div className="max-w-6xl mx-auto px-6" data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-77">
          <h2 className="font-editorial text-4xl md:text-5xl font-bold text-slate-900 mb-3" data-id="element-78">
            Triple Aim
          </h2>
          <p className="text-xl md:text-2xl font-medium text-slate-800 max-w-3xl mx-auto mb-3" data-id="element-79">
            Maximizing value for LEO, KEE experts, and HCPs
          </p>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-80">
            Three objectives driving the Master-Class experience
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-81">
          {objectives.map((obj, index) => <motion.div key={obj.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-slate-50 rounded-2xl p-8 border border-slate-200 hover:border-red-200 transition-colors" data-id="element-82">
              <obj.icon className="w-10 h-10 text-red-600 mb-4" strokeWidth={1.5} data-id="element-83" />
              <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-84">
                {obj.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-85">
                {obj.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}